<template>
  <r-custom-select-option :scope="scope">
    <q-item-section>
      {{ bankName }}
    </q-item-section>
    <q-item-section side>
      ({{ bankNumber }})
    </q-item-section>
  </r-custom-select-option>
</template>

<script>
import RCustomSelectOption from '@/components/base/RCustomSelectOption';

export default {
  name: 'BankOption',
  components: { RCustomSelectOption },
  props: {
    bankName: String,
    bankNumber: Number,
    scope: {
      type: Object,
      required: true,
    },
  },
};
</script>
